<p-dialog
  [(visible)]="visible"
  showEffect="fade"
  [modal]="true"
  [style]="{ width: '480px', 'min-height': '420px' }"
  [contentStyle]="{ overflow: 'visible' }"
  [closable]="!inviting"
  [closeOnEscape]="!inviting"
  [dismissableMask]="!inviting"
  (onHide)="close()"
  [draggable]="false">
  <ng-template pTemplate="header">
    <span class="font-bold text-lg block truncate max-w-[400px]" [title]="fileName">
      Dela "{{ fileName }}"
    </span>
  </ng-template>

  <div class="flex items-start gap-2 w-full">
    <p-dropdown
      class="min-w-0 flex-1 max-w-[66%]"
      styleClass="w-full"
      appendTo="body"
      [options]="invitableUsers"
      optionLabel="name"
      optionValue="id"
      [filter]="true"
      filterBy="name,email"
      [showClear]="true"
      [autoDisplayFirst]="false"
      [disabled]="loadingUsers"
      [placeholder]="loadingUsers ? 'Laddar användare...' : 'Sök person att bjuda in'"
      [(ngModel)]="selectedUserId">
      <ng-template pTemplate="selectedItem" let-user>
        <div class="truncate" [title]="userLabel(user)">{{ userLabel(user) }}</div>
      </ng-template>
      <ng-template pTemplate="item" let-user>
        <div class="max-w-[300px] truncate" [title]="userLabel(user)">{{ userLabel(user) }}</div>
      </ng-template>
    </p-dropdown>
    <p-dropdown
      *ngIf="selectedUserId"
      class="shrink-0"
      styleClass="min-w-36"
      appendTo="body"
      [options]="roleOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="selectedRole">
    </p-dropdown>
    <bl-frontend-button variant="primary" text="Bjud in" [disabled]="!canInvite" (onclick)="invite()">
    </bl-frontend-button>
  </div>

  <div *ngIf="canUploadWithoutRecipients" class="mt-3">
    <bl-frontend-button variant="secondary" text="Ladda upp utan att dela" (onclick)="uploadWithoutRecipients()">
    </bl-frontend-button>
  </div>

  <div class="mt-5">
    <label class="font-bold block">Vem har åtkomst</label>

    <div *ngIf="access.length === 0" class="mt-2 italic text-description">
      {{
        uploaded
          ? 'Filen har inga mottagare. Bjud in personer nu eller senare via "Hantera åtkomst".'
          : 'Filen har inte delats med någon Lundify-användare'
      }}
    </div>

    <div class="max-h-[290px] overflow-y-auto">
    <div *ngFor="let granted of access" class="mt-3 flex items-center justify-between gap-2">
      <span class="min-w-0 truncate" [title]="userName(granted.cloudUserId)">{{ userName(granted.cloudUserId) }}</span>
      <div class="flex items-center gap-2">
        <p-dropdown
          class="shrink-0"
          styleClass="min-w-36"
          appendTo="body"
          [options]="roleOptions"
          optionLabel="label"
          optionValue="value"
          [ngModel]="granted.role"
          [disabled]="pendingRoleChanges.has(granted.cloudUserId)"
          (ngModelChange)="changeRole(granted, $event)">
        </p-dropdown>
        <bl-frontend-button
          class="shrink-0"
          variant="tonal"
          density="slim"
          title="Ta bort åtkomst"
          [leadingIcon]="{ name: 'trash-alt' }"
          (onclick)="remove(granted)"></bl-frontend-button>
      </div>
    </div>
    </div>
  </div>
</p-dialog>
